
import React, { Component } from 'react';
import PropTypes, { number } from 'prop-types';
import { connect } from "react-redux";
import { mostrarModulo, actualizarMensaje } from "../../redux/actions/actGlobal";
import { mostrarModalDel } from "../../redux/actions/actGenericas";
import { obtenerValores, obtenerValoresFiltros, validarCorreo, obtenerPermisosValor, formulario, mostrarError, crear_form_data } from "../../global/js/funciones";
import { mostrarModalMensajeValidacionId } from "./../../redux/actions/actInscripciones";
import InscripcionForm from "./InscripcionForm";
import InscripcionFormV2 from "./v2/InscripcionFormV2";
import PantallaCierre from "./v2/PantallaCierre";
import CargandoInscripcion from "./v2/CargandoInscripcion";
import InscripcionInicio from "./InscripcionInicio";
import { periodoInscripcionAbierto } from "./periodoInscripcion";
import { formatoFecha } from "./validarIdentificacion";
import { cargarPreguntasCaracterizacion, limpiarOcultas, validarPasoCaracterizacion, armarCaracterizacion, pasoCaracterizacion } from "./v2/caracterizacion";
import { aceptacionesRequeridas, campoAceptacion } from "./v2/confirmacion";
import ConfirmarAccion from '../general/ConfirmarAccion';
import emma_s from "../../global/imagenes/emma_s1.png";
import TareasTerminadas from "./../general/TareasTerminadas";
import {
  GRUPOS_INSCRIPCIONES, DISCAPACIDADES_INSCRIPCIONES,
  VALIDACION_DOCUMENTOS_INSCRIPCIONES,
  TIPO_PRIMER_SEMESTRE,
  TIPO_HOMOLOGACION,
  EPS, SEDES,
  EPS_OTRO,
  TIPO_IDENTIFICACION,
  GENEROS
} from './helper';

// Formulario rediseñado (v2), solo para pregrado regular. Premédico (?tipo=premedico) sigue con el
// formulario actual. Para volver al formulario anterior en todos los casos, poner en false.
const USAR_FORM_V2 = true;

// Celular colombiano: 10 dígitos empezando por 3. Fijo: 7 a 10 dígitos (los nuevos son de 10, 60X...).
const CELULAR_VALIDO = /^3\d{9}$/;
const TELEFONO_VALIDO = /^\d{7,10}$/;

// Edad cumplida a hoy según la fecha de nacimiento
const edadEnAnios = (fecha) => {
  const nacimiento = new Date(fecha);
  const hoy = new Date();
  let edad = hoy.getFullYear() - nacimiento.getFullYear();
  const mes = hoy.getMonth() - nacimiento.getMonth();
  if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) edad--;
  return edad;
};

class InscripcionAgregar extends Component {
  constructor(props) {
    super(props)
    // Se decide desde el inicio para que el primer render ya use la versión correcta
    const tipoUrl = new URLSearchParams(props.location.search).get('tipo');
    this.state = {
      iniciar: false,
      tipo_identificacion: null,
      carrera: '',
      sede:'', 
      identificacion: '',
      primer_nombre: '',
      segundo_nombre: '',
      primer_apellido: '',
      segundo_apellido: '',
      telefono1: '',
      telefono2: '',
      celular1: '',
      celular2: '',
      correo: '',
      carreras: [],
      tipos_identificacion: [],
      sedes: [],
      opciones_conociste: [],
      opcion_conociste: '',
      departamentos: [],
      departamento: '',
      sedes: '',
      ciudades: [],
      carrerassedes: [],
      ciudad: '',
      estratos: [],
      estrato: '',
      barrio: '',
      direccion: '',
      guardado: false,
      enviando: false,
      adj_identificacion: '',
      adj_diploma: '',
      adj_saber: '',
      adj_identificacion_final: '',
      adj_diploma_final: '',
      adj_saber_final: '',
      generacion: '',
      grupos: [],
      grupo: '',
      discapacidades: [],
      discapacidad: '',
      adj_certificado: '',
      adj_certificado_final: '',
      adj_idpadres: '',
      adj_idpadres_final: '',
      menor_edad: false,
      mensaje_contacto: '',
      mostrar_btn: true,
      validacion_doc: [],
      mensaje_final: '',
      cargando: true,
      codigo_pruebas: '',
      puntaje_pruebas: '',
      puntaje_sisben: '',
      tiene_sisben: '',
      opciones_sisben: [
        {
          value: 'si',
          label: 'SI',
        },
        {
          value: 'no',
          label: 'NO',
        }
      ],
      link_politica: '',
      link_consentimiento_informado: '',
      tipo_inscripcion_preg: '',
      tipos_inscripcion_preg: [
        {
          value: TIPO_PRIMER_SEMESTRE,
          label: 'INSCRIPCIÓN PRIMER SEMESTRE',
        },
        {
          value: TIPO_HOMOLOGACION,
          label: 'HOMOLOGACIÓN',
        }
      ],
      habilitar_form: false,
      adj_docu_notas: '',
      adj_docu_notas_final: '',
      nombreEps : '',
      nombreEpsOtro : '',
      opcionesEps : [],
      mostrar_ciudades: true,
      mostrar_carreras: true,
      nombreEps: '', 
      nombreEpsOtro: '',
      opcionesEps: [],
      identificacion_saber: '',
      tipo_identificacion_saber: null,
      nombre_acudiente: '',
      celular_acudiente: '',
      correo_acudiente: '',
      generos: [],
      genero: null,
      fechaNacimiento: null,
      fechaExpedicion: null,
      prefijo_codigo: 'AC',
      canales_contacto: [],
      canal_contacto: '',
      tipo_inscripcion: null,
      campo_error: '',
      periodo_abierto: null,
      usar_v2: USAR_FORM_V2 && !tipoUrl,
      // Caracterización (formulario v2): preguntas del servicio y respuestas { codigo: { opciones, texto } }
      preguntas_caracterizacion: [],
      respuestas_caracterizacion: {},
      // Paso Confirmación (formulario v2): casillas marcadas { clave: true } y error del último envío
      aceptaciones: {},
      error_envio: '',
    }
  }

  componentDidMount() {
    this.cargarTipos();
    const params = new URLSearchParams(this.props.location.search);
    const tipo = params.get('tipo');

    this.setState({
      tipo_inscripcion: tipo ? tipo : null,
    });
    if (this.state.usar_v2) this.iniciarFormularioDirecto();
  }

  async componentDidUpdate({ }, { sede, departamento, tipo_inscripcion_preg, nombreEps, fechaNacimiento }) {
    // Formulario v2: "menor de edad" se calcula con la fecha de nacimiento (ya no hay casilla)
    if (this.state.usar_v2 && this.state.fechaNacimiento !== fechaNacimiento) {
      const menor = this.state.fechaNacimiento ? edadEnAnios(this.state.fechaNacimiento) < 18 : false;
      if (menor !== this.state.menor_edad) this.changeState('menor_edad', menor);
    }
    let {sede:sedeNew, departamento: departamentoNew, tipo_inscripcion_preg: tipo_inscripcion_pregNew } = this.state;
    if (departamentoNew.value && departamentoNew.value !== departamento.value) {
      this.changeState('ciudades', []); 
      this.changeState('mostrar_ciudades', false);

      let ciudades = await obtenerPermisosValor(departamentoNew.value);
      ciudades = ciudades.map(({ secundario }) => ({
        value: secundario.id,
        label: secundario.nombre,
      }));

      this.changeState('mostrar_ciudades', true);
      this.changeState('ciudades', ciudades);
      // Se conserva la ciudad (p. ej. autollenada) si pertenece al nuevo departamento
      if (!ciudades.some((c) => c.value === (this.state.ciudad && this.state.ciudad.value))) this.changeState('ciudad', '');
    }
    if (sedeNew.value && sedeNew.value !== sede.value) {
      this.changeState('carrerassedes', []); 
      this.changeState('mostrar_carreras', false);

      let carrerassedes= await obtenerPermisosValor(sedeNew.value);
      // El código se necesita para las reglas de Psicología (14011): documento de los padres y consentimiento informado
      carrerassedes = carrerassedes.map(({ secundario }) => ({
        value: secundario.id,
        label: secundario.nombre,
        codigo: secundario.codigo,
      }));

      this.changeState('mostrar_carreras', true);
      this.changeState('carrerassedes', carrerassedes);
      // Se conserva el programa (p. ej. autollenado) si se ofrece en la nueva sede
      if (!carrerassedes.some((c) => c.value === (this.state.carrera && this.state.carrera.value))) this.changeState('carrera', '');
    }

    if (tipo_inscripcion_pregNew.value && tipo_inscripcion_pregNew.value !== tipo_inscripcion_preg.value) {
      this.changeState('habilitar_form', true)
      console.log('tipo_inscripcion_pregNew', tipo_inscripcion_pregNew);

    }
    if (nombreEps !== this.state.nombreEps) {
      if (this.state.nombreEps.value !== EPS_OTRO) {
        let nombreEpsOtro = '';
        this.changeState('nombreEpsOtro', nombreEpsOtro);
      }
    }

  }

  // Formulario v2: sin pantalla de tarjetas. Si el periodo está abierto entra directo como
  // primer semestre (lo mismo que hacía el clic en la tarjeta); si está cerrado, se muestra la
  // pantalla de cierre de InscripcionInicio.
  iniciarFormularioDirecto = async () => {
    const abierto = await periodoInscripcionAbierto();
    if (abierto) {
      // Si el servicio de preguntas falla llega [] y el formulario sigue sin los pasos de caracterización
      const preguntas_caracterizacion = await cargarPreguntasCaracterizacion();
      this.setState({
        iniciar: true,
        tipo_inscripcion_preg: { value: TIPO_PRIMER_SEMESTRE, label: 'INSCRIPCIÓN PRIMER SEMESTRE' },
        preguntas_caracterizacion,
      });
    }
    this.setState({ periodo_abierto: abierto });
  }

  // Al modificar el campo marcado con error (campo_error), se quita la marca
  changeState = (name, value) => {
    this.setState(prev => ({
      [name]: value,
      ...(prev.campo_error === name ? { campo_error: '' } : {})
    }))
  }

  // Caracterización: actualiza la respuesta de una pregunta y borra las de las preguntas que dejan de aplicar
  setRespuestaCaracterizacion = (codigo, cambios) => {
    this.setState(prev => {
      const respuestas = { ...prev.respuestas_caracterizacion, [codigo]: { ...(prev.respuestas_caracterizacion[codigo] || {}), ...cambios } };
      return {
        respuestas_caracterizacion: limpiarOcultas(prev.preguntas_caracterizacion, respuestas),
        ...(prev.campo_error === codigo ? { campo_error: '' } : {})
      };
    })
  }

  // Paso Confirmación: marca o desmarca una casilla y quita su marca de error
  setAceptacion = (clave, valor) => {
    const campo = campoAceptacion(clave);
    this.setState(prev => ({
      aceptaciones: { ...prev.aceptaciones, [clave]: valor },
      ...(prev.campo_error === campo ? { campo_error: '' } : {})
    }))
  }

  aceptacionesRequeridas = () => aceptacionesRequeridas(this.state.carrera, this.state.preguntas_caracterizacion.length > 0);

  // Paso Confirmación: la primera casilla obligatoria sin marcar se pinta en rojo
  validarConfirmacion = () => {
    const falta = this.aceptacionesRequeridas().find(({ clave }) => !this.state.aceptaciones[clave]);
    this.setState({ campo_error: falta ? campoAceptacion(falta.clave) : '' });
    return falta ? falta.mensaje : '';
  }

  guardarInscripcion = async () => {
    let { mostrarModalDel, actualizarMensaje } = this.props;
    // Evita el doble envío (doble clic o reintento mientras sigue el anterior)
    if (this.state.enviando) return;
    this.setState({ enviando: true, error_envio: '' });
    // El formulario v2 muestra la capa de "Enviando"; el anterior, el aviso de siempre
    if (!this.state.usar_v2) actualizarMensaje({ titulo: 'Enviado datos, por favor espere...', tipo: 'info', mostrar: true, tiempo: 10000 });
    let {
      tipo_identificacion,
      identificacion,
      primer_nombre,
      primer_apellido,
      segundo_nombre,
      segundo_apellido,
      correo,
      carrera,
      sede,
      opcion_conociste,
      celular1,
      celular2,
      telefono1,
      telefono2,
      departamento,
      ciudad,
      estrato,
      barrio,
      direccion,
      adj_identificacion_final,
      adj_diploma_final,
      adj_saber_final,
      grupo,
      discapacidad,
      adj_certificado_final,
      adj_idpadres_final,
      codigo_pruebas,
      puntaje_pruebas,
      puntaje_sisben,
      tiene_sisben,
      nombreEps,
      nombreEpsOtro,
      adj_docu_notas_final,
      tipo_inscripcion_preg,
      nombre_acudiente,
      celular_acudiente,
      correo_acudiente,
      identificacion_saber,
      tipo_identificacion_saber,
      genero,
      fechaNacimiento,
      fechaExpedicion,
      prefijo_codigo,
      canal_contacto,
      tipo_inscripcion,
    } = this.state;
    if (prefijo_codigo != '') codigo_pruebas = `${prefijo_codigo} ${codigo_pruebas}`;
    let usuario = correo.split("@")[0]
    if (tipo_inscripcion === 'premedico') carrera = { value: 33249, label: 'PREMEDICO' }; //ID CARRERA PREMEDICO
    let data = await crear_form_data({
      tipo_identificacion: tipo_identificacion.value,
      identificacion,
      primer_nombre,
      primer_apellido,
      segundo_nombre,
      segundo_apellido,
      correo,
      carrera: carrera.value,
      sede: sede.value,
      conocio: opcion_conociste.value,
      celular1,
      celular2,
      telefono1,
      telefono2,
      departamento: departamento.value,
      ciudad: ciudad.value,
      estrato: estrato.value,
      barrio,
      direccion,
      usuario,
      adj_identificacion: adj_identificacion_final,
      adj_diploma: adj_diploma_final,
      adj_saber: adj_saber_final,
      adj_certificado: adj_certificado_final,
      adj_idpadres: adj_idpadres_final,
      grupo: grupo.value,
      discapacidad: discapacidad ? discapacidad.value : '',
      codigo_pruebas,
      puntaje_pruebas,
      // puntaje_sisben,
      // sisben: tiene_sisben.value,
      adj_docu_notas: adj_docu_notas_final,
      tipo: tipo_inscripcion_preg.value,
      nombre_eps: nombreEps.value,
      nombre_otro_eps: nombreEpsOtro,
      nombre_acudiente,
      celular_acudiente,
      correo_acudiente,
      // Formulario v2: ya no se piden; se envían con el documento del aspirante (el backend los exige)
      identificacion_saber: this.state.usar_v2 ? identificacion : identificacion_saber,
      tipo_identificacion_saber: this.state.usar_v2
        ? (tipo_identificacion ? tipo_identificacion.value : '')
        : (tipo_identificacion_saber ? tipo_identificacion_saber.value : ''),
      genero: genero.value,
      // Fechas en hora local (toISOString las corría un día después de las 7:00 p. m.)
      fecha_nacimiento: formatoFecha(fechaNacimiento),
      fecha_expedicion: formatoFecha(fechaExpedicion),
      canal_contacto: canal_contacto.value,
      // Solo el formulario v2 envía la caracterización (premédico y el formulario anterior no la tienen)
      ...(this.state.usar_v2 && this.state.preguntas_caracterizacion.length
        ? { caracterizacion: JSON.stringify(armarCaracterizacion(this.state.preguntas_caracterizacion, this.state.respuestas_caracterizacion)) }
        : {}),
      // Formulario v2: aceptaciones del paso Confirmación (el backend las vuelve a validar y las guarda como evidencia)
      ...(this.state.usar_v2
        ? { aceptaciones: JSON.stringify(this.aceptacionesRequeridas().reduce((acc, { clave }) => ({ ...acc, [clave]: !!this.state.aceptaciones[clave] }), {})) }
        : {}),
    });
    formulario("api/v1.0/inscripciones/crear", data, "post",
      async (error, estado, resp) => {
        if (!error && estado === 200) {
          this.setState({ guardado: true, enviando: false });
          mostrarModalDel(false);
          actualizarMensaje({ titulo: resp.titulo, tipo: 'success', mostrar: true, tiempo: 6000 });
          return;
        }
        // Sin respuesta legible (sin conexión o caída del servidor), error del servidor (500) o validación (302/400)
        let titulo;
        if (error) titulo = 'No pudimos comunicarnos con el servidor. Revisa tu conexión a internet e intenta de nuevo.';
        else if (resp && resp.titulo) titulo = resp.titulo;
        else if (estado >= 500) titulo = 'No pudimos guardar tu inscripción. Intenta de nuevo en unos minutos.';
        else titulo = mostrarError(resp);
        // El v2 muestra el error dentro del paso Confirmación (no se pierde lo diligenciado); el anterior, en el aviso
        this.setState({ enviando: false, error_envio: titulo });
        if (!this.state.usar_v2) actualizarMensaje({ titulo, tipo: error || estado >= 500 ? 'error' : 'info', mostrar: true, tiempo: 6000 });
      }, false
    );

  }

  onChange = ({ target }) => {
    let { value, name } = target;
    if (name != 'codigo_pruebas' || (name == 'codigo_pruebas' && value.length >= 2)) {
      this.setState(prev => ({
        [name]: value.replace(/[À-ÿ]/g, ''),
        ...(prev.campo_error === name ? { campo_error: '' } : {})
      }))
    }
  }

  checked = ({ target }) => {
    this.setState({
      [target.name]: target.checked
    })
  }

  cargarTipos = async () => {
    const transformar = data => {
      return data.map(e => ({
        value: e.id,
        label: e.nombre,
        codigo: e.codigo,
      }));
    }
    const mensaje = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Men_Ins' }]);
    const validacionDocs = await obtenerValores(VALIDACION_DOCUMENTOS_INSCRIPCIONES);
    // const carreras = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': 5 }, { 'llave': 'valora', 'valor': 'ofertado' }, { 'llave': 'valorc', 'valor': 'pregrado' }]);
    const tipos_identificacion = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPO_IDENTIFICACION }, { 'llave': 'valora', 'valor': 'persona' }]);
    const opciones_conociste = await obtenerValores(6);
    const sedes = await obtenerValores(SEDES);
    const departamentos = await obtenerValores(7);
    const estratos = await obtenerValores(9);
    const grupos = await obtenerValores(GRUPOS_INSCRIPCIONES);
    const discapacidades = await obtenerValores(DISCAPACIDADES_INSCRIPCIONES);
    const mensajefin = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Men_Ins_Fin' }]);
    const politica = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Pol_Dat_Cuc' }]);
    const consentimiento_informado = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Con_Inf_Ins' }]);
    const epsResp = await obtenerValores(EPS);
    const canales_contacto = await obtenerValores(359);
    let generos = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': GENEROS }]);
    generos = generos.filter(genero => genero.codigo !== 'no_aplica');
    this.setState({
      // carreras: transformar(carreras),
      tipos_identificacion: transformar(tipos_identificacion),
      sedes: transformar(sedes),
      opciones_conociste: transformar(opciones_conociste),
      departamentos: transformar(departamentos),
      estratos: transformar(estratos),
      grupos: transformar(grupos),
      discapacidades: transformar(discapacidades),
      mensaje_contacto: mensaje[0].nombre,
      validacion_doc: validacionDocs.sort((a, b) => a.valorb - b.valorb).map(e => ({ id: e.id, nombre: e.nombre, valora: e.valora, estado: e.estado })),
      mensaje_final: mensajefin[0].nombre,
      link_politica: politica && politica[0] ? politica[0].archivo : '',
      link_consentimiento_informado: consentimiento_informado && consentimiento_informado[0] ? consentimiento_informado[0].archivo : '',
      opcionesEps: transformar(epsResp),
      generos: transformar(generos),
      canales_contacto: transformar(canales_contacto),
      cargando: false
    })
  }

  validarDatos = (step) => {
    let {
      carrera,
      sede,
      tipo_identificacion,
      identificacion,
      primer_nombre,
      primer_apellido,
      correo,
      telefono1,
      celular1,
      opcion_conociste,
      departamento,
      ciudad,
      estrato,
      barrio,
      direccion,
      adj_diploma,
      adj_saber,
      adj_identificacion,
      grupo,
      discapacidad,
      adj_idpadres,
      menor_edad,
      adj_certificado,
      validacion_doc,
      codigo_pruebas,
      puntaje_pruebas,
      // puntaje_sisben,
      // tiene_sisben,
      tipo_inscripcion_preg,
      adj_docu_notas,
      nombreEps,
      nombreEpsOtro,
      identificacion_saber,
      tipo_identificacion_saber,
      nombre_acudiente,
      celular_acudiente,
      correo_acudiente,
      genero,
      fechaNacimiento,
      fechaExpedicion,
      prefijo_codigo,
      canal_contacto,
      tipo_inscripcion,
    } = this.state;
    let mensaje = '';
    let campo = '';

    if (step === 2) {
      // Mismo orden en que se muestran los campos en el formulario (v2)
      const reglas = [
        [!sede && tipo_inscripcion == null, 'Seleccione Sede.', 'sede'],
        [!carrera && tipo_inscripcion == null, 'Seleccione carrera.', 'carrera'],
        [(menor_edad && carrera.codigo == '14011') && !adj_idpadres, 'Debe adjuntar la identificación de los padres.', 'adj_idpadres'],
        [!opcion_conociste, 'Seleccione como nos conociste.', 'opcion_conociste'],
      ];
      const falla = reglas.find(([condicion]) => condicion);
      if (falla) {
        mensaje = falla[1];
        campo = falla[2];
      } else if (!this.state.usar_v2) {
        let adj_pa = document.getElementById('adj_idpadres')?.files[0];
        if (adj_pa) this.changeState('adj_idpadres_final', adj_pa);
      }

    } else if (step === 0) {
      // Mismo orden en que se muestran los campos en el formulario (v2).
      // Cada regla: [condición de error, mensaje, campo del estado que se marca en rojo]
      const reglas = [
        [!tipo_inscripcion_preg, 'Seleccione el motivo de la solicitud.', 'tipo_inscripcion_preg'],
        // Identificación
        [!tipo_identificacion, 'Seleccione tipo identificación.', 'tipo_identificacion'],
        [!identificacion, 'Ingrese identificación.', 'identificacion'],
        [!fechaExpedicion, 'Ingrese fecha de expedición del documento.', 'fechaExpedicion'],
        // Datos personales
        [!primer_nombre, 'Ingrese primer nombre.', 'primer_nombre'],
        [!primer_apellido, 'Ingrese primer apellido.', 'primer_apellido'],
        [!genero, 'Seleccione el género.', 'genero'],
        [!fechaNacimiento, 'Ingrese fecha de nacimiento.', 'fechaNacimiento'],
        // Contacto
        [!celular1, 'Ingrese celular.', 'celular1'],
        [!CELULAR_VALIDO.test(String(celular1)), 'El celular debe tener 10 dígitos y empezar por 3.', 'celular1'],
        [!telefono1, 'Ingrese teléfono fijo.', 'telefono1'],
        [!TELEFONO_VALIDO.test(String(telefono1)), 'El teléfono fijo debe tener entre 7 y 10 dígitos.', 'telefono1'],
        [!correo, 'Ingrese correo personal.', 'correo'],
        [!validarCorreo(correo), 'Correo personal invalido.', 'correo'],
        // Acudiente
        [!nombre_acudiente, 'Ingrese nombre acudiente.', 'nombre_acudiente'],
        [!celular_acudiente, 'Ingrese celular del acudiente.', 'celular_acudiente'],
        [!CELULAR_VALIDO.test(String(celular_acudiente)), 'El celular del acudiente debe tener 10 dígitos y empezar por 3.', 'celular_acudiente'],
        [!correo_acudiente, 'Ingrese correo acudiente.', 'correo_acudiente'],
        [!validarCorreo(correo_acudiente), 'Correo del acudiente inválido.', 'correo_acudiente'],
        // Pruebas Saber 11
        // Solo en el formulario anterior (premédico); el v2 ya no pide estos dos campos
        [!this.state.usar_v2 && !tipo_identificacion_saber, 'Seleccione el tipo de identificación con la que presentó las pruebas saber.', 'tipo_identificacion_saber'],
        [!this.state.usar_v2 && !identificacion_saber, 'Ingrese identificación pruebas saber.', 'identificacion_saber'],
        [!prefijo_codigo, 'Seleccione el prefijo del código de pruebas.', 'prefijo_codigo'],
        [codigo_pruebas.length < 10, 'Ingrese codigo de pruebas valido.', 'codigo_pruebas'],
        [!puntaje_pruebas, 'Ingrese puntaje global pruebas.', 'puntaje_pruebas'],
        // Grupo o comunidad
        [!grupo, 'Seleccione a que grupo pertenece.', 'grupo'],
        [grupo.codigo === 'GRU_DIS' && !discapacidad, 'Seleccione el tipo de discapacidad.', 'discapacidad'],
        // Documentos
        [!adj_identificacion && validacion_doc[0].valora === '1', 'Debe adjuntar la identificación.', 'adj_identificacion'],
        [!adj_diploma && validacion_doc[2].valora === '1', 'Debe adjuntar el diploma.', 'adj_diploma'],
        [!adj_saber && validacion_doc[1].valora === '1', 'Debe adjunta tu documento de resultado pruebas saber 11.', 'adj_saber'],
        [(grupo !== '' && grupo.codigo !== 'GRU_NIN') && (!adj_certificado && validacion_doc[3].valora === '1'), 'Debe adjuntar el certificado de comunidad especial.', 'adj_certificado'],
        [tipo_inscripcion_preg && tipo_inscripcion_preg.value == TIPO_HOMOLOGACION && !adj_docu_notas && validacion_doc[4].valora === '1', 'Debe adjunta tu documento de notas.', 'adj_docu_notas'],
      ];
      const falla = reglas.find(([condicion]) => condicion);
      if (falla) {
        mensaje = falla[1];
        campo = falla[2];
      }
      else if (!this.state.usar_v2) {
        // Formulario anterior: los archivos se leen de los inputs ocultos (el v2 ya los tiene en el estado)
        let adj_id = document.getElementById('adj_identificacion')?.files[0];
        let adj_di = document.getElementById('adj_diploma')?.files[0];
        let adj_sa = document.getElementById('adj_saber')?.files[0];
        let adj_ce = document.getElementById('adj_certificado')?.files[0];
        let adj_no = document.getElementById('adj_docu_notas')?.files[0];
        if (adj_id) this.changeState('adj_identificacion_final', adj_id);
        if (adj_di) this.changeState('adj_diploma_final', adj_di);
        if (adj_sa) this.changeState('adj_saber_final', adj_sa);
        if (adj_ce) this.changeState('adj_certificado_final', adj_ce);
        if (adj_no) this.changeState('adj_docu_notas_final', adj_no);
      }
    } else if (step === 1) {
      // Mismo orden en que se muestran los campos en el formulario (v2)
      const reglas = [
        [!departamento, 'Seleccione departamento.', 'departamento'],
        [!ciudad, 'Seleccione ciudad o municipio.', 'ciudad'],
        [!barrio, 'Ingrese barrio.', 'barrio'],
        [!direccion, 'Ingrese Dirección.', 'direccion'],
        [!estrato, 'Seleccione estrato.', 'estrato'],
        // El autollenado deja { value: '' } cuando no había EPS: también cuenta como vacío
        [!nombreEps || !nombreEps.value, 'Seleccione EPS.', 'nombreEps'],
        [nombreEps.value === EPS_OTRO && !nombreEpsOtro, 'Ingrese nombre de la EPS.', 'nombreEpsOtro'],
        [!canal_contacto, 'Seleccione canal de contacto.', 'canal_contacto'],
      ];
      const falla = reglas.find(([condicion]) => condicion);
      if (falla) {
        mensaje = falla[1];
        campo = falla[2];
      }
      // else if (!carrera) mensaje = '¿Que quieres estudiar?.';
    } else if (pasoCaracterizacion(step)) {
      // Caracterización: la pregunta sin responder se marca con su código
      [mensaje, campo] = validarPasoCaracterizacion(this.state.preguntas_caracterizacion, this.state.respuestas_caracterizacion, pasoCaracterizacion(step));
    }
    this.setState({ campo_error: campo });
    return mensaje;
  }


  render() {
    let {
      carrera,
      sede,
      tipo_identificacion,
      carreras,
      tipos_identificacion,
      identificacion,
      primer_nombre,
      segundo_nombre,
      primer_apellido,
      segundo_apellido,
      correo,
      telefono1,
      telefono2,
      celular1,
      celular2,
      sedes,
      opciones_conociste,
      opcion_conociste,
      departamentos,
      departamento,
      ciudades,
      carrerassedes,
      ciudad,
      estratos,
      estrato,
      barrio,
      direccion,
      guardado,
      adj_identificacion,
      adj_identificacion_final,
      iniciar,
      adj_diploma,
      adj_diploma_final,
      adj_saber,
      adj_saber_final,
      grupos,
      grupo,
      discapacidades,
      discapacidad,
      adj_certificado,
      adj_certificado_final,
      adj_idpadres,
      adj_idpadres_final,
      menor_edad,
      mensaje_contacto,
      mostrar_btn,
      validacion_doc,
      mensaje_final,
      cargando,
      codigo_pruebas,
      puntaje_pruebas,
      puntaje_sisben,
      opciones_sisben,
      tiene_sisben,
      link_politica,
      link_consentimiento_informado,
      tipo_inscripcion_preg,
      tipos_inscripcion_preg,
      habilitar_form,
      adj_docu_notas,
      adj_docu_notas_final,
      opcionesEps,
      nombreEps,
      nombreEpsOtro,
      mostrar_ciudades,
      mostrar_carreras,
      identificacion_saber,
      tipo_identificacion_saber,
      nombre_acudiente,
      celular_acudiente,
      correo_acudiente,
      generos,
      genero,
      fechaNacimiento,
      fechaExpedicion,
      prefijo_codigo,
      canales_contacto,
      canal_contacto,
      tipo_inscripcion,
    } = this.state;

    let { actualizarMensaje, modalDel, mostrarModalDel, modalMensajeValidacionId, mostrarModalMensajeValidacionId } = this.props;
    const mensajeAlerta = `En caso de que presentes algún inconveniente en el momento de realizar tu proceso de inscripción ${mensaje_contacto}`
    const { usar_v2 } = this.state;
    if (cargando || (usar_v2 && this.state.periodo_abierto === null)) {
      if (usar_v2) return <CargandoInscripcion />;
      return <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_s} widthImg="7%" cargando={true} />;
    }
    // Formulario v2: periodo cerrado -> pantalla de cierre nueva
    if (usar_v2 && this.state.periodo_abierto === false) {
      return <PantallaCierre linkPolitica={link_politica} />;
    }
    const Formulario = usar_v2 ? InscripcionFormV2 : InscripcionForm;
    if (iniciar) {
      return (
        <div>
          {/* Solo el formulario anterior (premédico) acepta en este modal; el v2 lo hace en el paso Confirmación */}
          <ConfirmarAccion
            mensaje2=''
            mensaje1={carrera.codigo == '14011' ?
              <div style={{ textAlign: 'justify' }}><span>
                Para tu ingreso al PROGRAMA DE PSICOLOGIA de la Universidad de la Costa, es importante contar con tu aprobación para la realización de una prueba psicotécnica, por tanto debes aceptar los términos y condiciones expresados en el <a href={link_consentimiento_informado} target='_black' className='sin_decorador' style={{ color: 'black' }}>consentimiento
                  informado</a> y aceptar las <a href={link_politica} target='_black' className='sin_decorador' style={{ color: 'black' }}>políticas de protección de datos</a> de la Universidad de la Costa.<br /><br />
                Al continuar, se da a entender la aprobación de los términos y condiciones.</span></div> :
              <div style={{ textAlign: 'justify' }}><span style={{ textAlign: 'justify' }}>
                Al continuar usted acepta las políticas de protección de datos de la Universidad de la Costa.<br /><a href={link_politica} target='_black' className='sin_decorador' style={{ color: 'black' }}> Ver políticas</a></span></div>
            }
            ejecutarAccion={this.guardarInscripcion} mostrarModalConfAccion={mostrarModalDel} modalConAccion={modalDel} dato={{ id: 0 }} titulo={'¿ Enviar Datos ?'} />
          <Formulario
            props_c={{
              obtenerValores: () => obtenerValores,
              primer_nombre,
              segundo_nombre,
              primer_apellido,
              segundo_apellido,
              correo,
              carrera,
              sede,
              tipo_identificacion,
              carreras,
              tipos_identificacion,
              identificacion,
              telefono1,
              telefono2,
              celular1,
              celular2,
              sedes,
              opciones_conociste,
              opcion_conociste,
              departamentos,
              departamento,
              ciudades,
              carrerassedes,
              estratos,
              estrato,
              ciudad,
              barrio,
              direccion,
              grupos,
              grupo,
              discapacidades,
              discapacidad,
              opcionesEps,
              nombreEps,
              nombreEpsOtro,
              onChange: this.onChange,
              checked: this.checked,
              validarDatos: this.validarDatos,
              actualizarMensaje,
              terminarProceso: mostrarModalDel,
              guardado,
              adj_identificacion,
              adj_identificacion_final,
              adj_diploma,
              adj_diploma_final,
              adj_saber,
              adj_saber_final,
              adj_certificado,
              adj_certificado_final,
              adj_idpadres,
              adj_idpadres_final,
              menor_edad,
              mensaje: mensaje_contacto,
              mensaje_final,
              mostrar_btn,
              validacion_doc,
              codigo_pruebas,
              puntaje_pruebas,
              puntaje_sisben,
              tiene_sisben,
              opciones_sisben,
              modalMensajeValidacionId,
              mostrarModalMensajeValidacionId,
              mensajeAlerta,
              link_consentimiento_informado,
              link_politica,
              tipo_inscripcion_preg,
              tipos_inscripcion_preg,
              habilitar_form,
              adj_docu_notas,
              adj_docu_notas_final,
              nombre_acudiente,
              celular_acudiente,
              correo_acudiente,
              identificacion_saber,
              tipo_identificacion_saber,
              generos,
              genero,
              fechaNacimiento,
              fechaExpedicion,
              prefijo_codigo,
              canales_contacto,
              canal_contacto,
              tipo_inscripcion,
              campo_error: this.state.campo_error,
              preguntas_caracterizacion: this.state.preguntas_caracterizacion,
              respuestas_caracterizacion: this.state.respuestas_caracterizacion,
              setRespuestaCaracterizacion: this.setRespuestaCaracterizacion,
              // Paso Confirmación y envío (formulario v2)
              aceptaciones: this.state.aceptaciones,
              aceptaciones_requeridas: this.aceptacionesRequeridas(),
              setAceptacion: this.setAceptacion,
              validarConfirmacion: this.validarConfirmacion,
              enviarInscripcion: this.guardarInscripcion,
              enviando: this.state.enviando,
              error_envio: this.state.error_envio,
              setNombreEps: (value) => {
                this.changeState('nombreEps', value)
              },
              setNombreEpsOtro: (value) => {
                this.changeState('nombreEpsOtro', value)
              },
              setTipo_identificacion: (value) => {
                this.changeState('tipo_identificacion', value)
              },
              setPrimer_nombre: (value) => {
                this.changeState('primer_nombre', value)
              },
              setSegundo_nombre: (value) => {
                this.changeState('segundo_nombre', value)
              },
              setPrimer_apellido: (value) => {
                this.changeState('primer_apellido', value)
              },
              setSegundo_apellido: (value) => {
                this.changeState('segundo_apellido', value)
              },
              setTelefono1: (value) => {
                this.changeState('telefono1', value)
              },
              setCelular1: (value) => {
                this.changeState('celular1', value)
              },
              setCorreo: (value) => {
                this.changeState('correo', value)
              },
              setCodigo_pruebas: (value) => {
                this.changeState('codigo_pruebas', value)
              },
              setPuntaje_pruebas: (value) => {
                this.changeState('puntaje_pruebas', value)
              },
              setPuntaje_sisben: (value) => {
                this.changeState('puntaje_sisben', value)
              },
              setAdj_identificacion: (value) => {
                this.changeState('adj_identificacion', value)
              },
              setAdj_diploma: (value) => {
                this.changeState('adj_diploma', value)
              },
              setAdj_saber: (value) => {
                this.changeState('adj_saber', value)
              },
              setAdj_certificado: (value) => {
                this.changeState('adj_certificado', value)
              },
              setOpcion_sedes:(value) => {
                this.changeState('sede', value)
              },
              setOpcion_conociste: (value) => {
                this.changeState('opcion_conociste', value)
              },
              setDepartamento: (value) => {
                this.changeState('departamento', value)
              },
              setCiudad: (value) => {
                this.changeState('ciudad', value)
              },
              setBarrio: (value) => {
                this.changeState('barrio', value)
              },
              setDireccion: (value) => {
                this.changeState('direccion', value)
              },
              setEstrato: (value) => {
                this.changeState('estrato', value)
              },
              setGrupo: (value) => {
                this.changeState('grupo', value)
              },
              setDiscapacidad: (value) => {
                this.changeState('discapacidad', value)
              },
              setMostrarBtn: (value) => {
                this.changeState('mostrar_btn', value)
              },
              setOpcion_sisben: (value) => {
                this.changeState('tiene_sisben', value)
              },
              setCarrera: (value) => {
                this.changeState('carrera', value)
              },
              setTipoInscripcionPreg: (value) => {
                this.changeState('tipo_inscripcion_preg', value)
              },
              setAdj_docu_notas: (value) => {
                this.changeState('adj_docu_notas', value)
              },
              mostrar_ciudades, mostrar_carreras,
              setIdentificacion_saber: (value) => {
                this.changeState('identificacion_saber', value)
              },
              setTipo_identificacion_saber: (value) => {
               this.changeState('tipo_identificacion_saber', value)
              },
              setNombreAcudiente: (value) => {
                this.changeState('nombre_acudiente', value)
              },
              setCedulaAcudiente: (value) => {
                this.changeState('celular_acudiente', value)
              },
              setCorreoAcudiente: (value) => {
                this.changeState('correo_acudiente', value)
              },
              setGenero: (value) => {
                this.changeState('genero', value)
              },
              setFechaNacimiento: (value) => {
                this.changeState('fechaNacimiento', value)
              },
              setFechaExpedicion: (value) => {
                this.changeState('fechaExpedicion', value)
              },
              setPrefijoCodigo: (value) => {
                this.changeState('prefijo_codigo', value)
              },
              // Formulario v2: guarda el nombre (para validar/mostrar) y el archivo real que se envía
              setArchivo: (campo, archivo) => {
                this.setState(prev => ({
                  [campo]: archivo ? archivo.name : '',
                  [`${campo}_final`]: archivo || '',
                  ...(prev.campo_error === campo ? { campo_error: '' } : {})
                }))
              },
              setCanalContacto: (value) => {
                this.changeState('canal_contacto', value)
              }
            }}
          />
        </div>
      )
    } else {
      return <InscripcionInicio mensaje={mensajeAlerta} accion={(tipo) => {
        console.log('tipo', tipo);
        this.changeState('iniciar', true)
        if (tipo === 'Tipo_Homo') {
          this.changeState('tipo_inscripcion_preg', {
            value: TIPO_HOMOLOGACION,
            label: 'HOMOLOGACIÓN',
          })
        } else if (tipo === 'Tipo_Ins') {
          this.changeState('tipo_inscripcion_preg', {
            value: TIPO_PRIMER_SEMESTRE,
            label: 'INSCRIPCIÓN PRIMER SEMESTRE',
          })
        }
      }
      } />
    }
  }
}

//CARGO ESTADOS DEL MODULO
const mapStateToProps = (state) => {
  let { modalDel } = state.redGenericas;
  let { modalMensajeValidacionId } = state.redInscripciones;
  return {
    modalDel,
    modalMensajeValidacionId,
  }
};

//CARGO FUNCIONES DEL MODULO
const mapDispatchToProps = {
  actualizarMensaje,
  mostrarModulo,
  mostrarModalDel,
  mostrarModalMensajeValidacionId
}

InscripcionAgregar.propTypes = {
  //variables
  modalDel: PropTypes.bool.isRequired,
  modalMensajeValidacionId: PropTypes.bool.isRequired,
  actualizarMensaje: PropTypes.func.isRequired,
  mostrarModulo: PropTypes.func.isRequired,
  mostrarModalDel: PropTypes.func.isRequired,
  mostrarModalMensajeValidacionId: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(InscripcionAgregar);
